import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserRole } from '@klubovna/api-client';
import { AuthService } from '../services';
import { UserFacade } from '../store/user/user.facade';

export const roleGuard: CanActivateFn = (route, state) => {
  const userFacade = inject(UserFacade);
  const router = inject(Router);
  const authService = inject(AuthService);

  const requiredRoles = route.data['roles'] as UserRole[] || [];

  const hasAuthContext = userFacade.isAuthenticated() || userFacade.user() || authService.hasStoredToken();

  if (!hasAuthContext) {
    return router.createUrlTree([ '/login' ], { queryParams: { returnUrl: state.url } });
  }

  if (!userFacade.isAuthenticated()) {
    userFacade.validateTokenWhenNeeded();
  }

  if (requiredRoles.length === 0) {
    return true;
  }

  const role = userFacade.userRole();
  const additionalRoles = userFacade.additionalRoles();

  const hasPrimaryRole = role && requiredRoles.includes(role);
  const hasAdditionalRole = additionalRoles.some(r => requiredRoles.includes(r));

  if (hasPrimaryRole || hasAdditionalRole) {
    return true;
  }

  if (!role && hasAuthContext) {
    return true;
  }

  return router.createUrlTree([ '/' ]);
};
